export enum TechnicalSettingsActionsTypes {
  READ = "@@WINDOW read perfumebag sizes",
  READ_STATUS = "@@WINDOW read status perfumebag sizes",
  PATCH_ONE = "@@WINDOW patch one ",
  PATCH_ONE_STATUS = "@@WINDOW patch one status "
}
